// Internal
import * as Auth from './auth';

const BASE_API_URL = process.env.REACT_APP_INV_360_API_URL;
const PATH_LOGIN = 'auth/login';
const PATH_ACCOUNT = 'account';
const PATH_PDF = '/pdf';
const PATH_VEHICLES = 'vehicles';
const baseHeader = {
  'Content-Type': 'application/json'
};

/**
 * Joins paths by `/`.
 * @param {string...} paths
 * @returns {string}
 */
const joinPaths = (...paths) => paths.join('/');

/**
 * Gets a post request body.
 * @param payload
 */
const getPostRequestBody = (payload) => {
  return {
    method: 'POST',
    body: JSON.stringify(payload)
  }
};

/**
 * Attempts to log in the user.
 * @param {string} username
 * @param {string} password
 * @returns {Promise<Response | Error>}
 */
export const login = (username, password) => {
  const options = {
      headers: baseHeader,
      ...getPostRequestBody({
        username,
        password
      })
    },
    url = joinPaths(BASE_API_URL, PATH_LOGIN);

  return fetch(url, options).then(res => res.json());
};

/**
 * Gets the vehicles from the specific account if no continuation url is passed.
 * @param {string} account
 * @param {string} nextUrl
 * @returns {Promise<Response | Error>}
 */
export const vehicles = (account, nextUrl) => {
  const token = Auth.getToken(),
    options = {
      method: 'GET',
      headers: {
        ...baseHeader,
        Authorization: `Bearer ${token}`,
        Accept: 'application/json'
      }
    },
    url = nextUrl || joinPaths(BASE_API_URL, PATH_ACCOUNT, account, PATH_VEHICLES);

  return fetch(url.replace('http:', 'https:'), options).then(res => res.json()).then((data) => data);
};

/**
 * Generates a PDF document based on the `HTML`.
 * @param {string} html
 * @returns {Promise<Blob | Error>}
 */
export const generatePdf = (html) => {
  const body = {
      html,
    },
    options = {
      headers: baseHeader,
      ...getPostRequestBody(body)
    };

  return fetch(PATH_PDF, options).then(res => res.blob()).then((res) => res);
};



// WEBPACK FOOTER //
// ./src/utils/api.js